import React, { useState } from 'lib/react';
import {
  EVTypography, EVLink, EVAdd, EVRemove, EVIconButton, EVGrid,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { LEGACY_PORTAL_LINKS } from 'constants/AppConstants';
import clsx from 'lib/clsx';
import useMediaQuery from 'hooks/useMediaQuery';
import FooterStyles from './FooterStyles';

function Footer() {
  const classes = FooterStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(640);
  const [expandedFooter, setExpandedFooter] = useState(false);

  return (
    <footer className={classes.footer}>
      <EVTypography className={classes.footerLinksContainer}>
        <EVLink target="_blank" href={LEGACY_PORTAL_LINKS.termsOfUse}>{t('finalize_order__order_summary__payment_terms_of_use_2')}</EVLink>
        {' | '}
        <EVLink target="_blank" href={LEGACY_PORTAL_LINKS.privacyPolicy}>{t('privacy_policy')}</EVLink>
      </EVTypography>
      <EVGrid container className={classes.footerDisclaimerContainer}>
        <EVTypography className={clsx(classes.footerDisclaimerText, isMobile && !expandedFooter && classes.expandedMenuLink)}>
          © 2025 Eagle View Technologies, Inc. and Pictometry International Corp. All Rights Reserved.
          Reports issued by EagleView Technologies are covered by
          {' '}
          one or more international and U.S. patents and pending applications, including U.S. Patent Nos. 8,078,436; 8,145,578; 8,170,840; 8,209,152;
          {' '}
          8,515,125; 8,825,454; 9,135,737; 8,670,961; 9,514,568; 8,818,770; 8,542,880; 9,244,589; 9,329,749; 8,938,090 and 9,183,538.
          Other Patents Pending.
        </EVTypography>
        {isMobile && (
        <EVIconButton
          id="expand-footer-button"
          className={classes.footerIcon}
          onClick={() => setExpandedFooter(!expandedFooter)}
          aria-expanded={expandedFooter}
          aria-controls="footer"
        >
          {
              expandedFooter
                ? <EVRemove id="remove-icon" htmlColor="#007CAD" />
                : <EVAdd id="add-icon" htmlColor="#007CAD" />
            }
        </EVIconButton>
        )}
      </EVGrid>
    </footer>
  );
}

export default Footer;
